

import React, {useEffect, useState} from 'react';
import {ImportCsvAlkis} from './ImportCsvAlkis';
import ViewButtons from '../../global/ViewButtons';
import {ImportDummy} from './ImportDummy';

type Props = {
    name:string,
    project:any,
    id:number,
    importCallback:any
}

/**
 * Form for editing and creating of projects
 * @param props
 * @constructor
 */
const ImportForm = (props: Props): JSX.Element => {

    const onSubmit=()=>{
        console.log('saved Import id '+props.id);
       // props.importCallback(true);
    };

    const parentCallback=(value:any)=>{
        props.importCallback(value);
    };


    useEffect(() => {
        console.log('loaded import overview', props);
    }, [props.name]);

    return (<div>
        {props.id===1 &&
            <ImportCsvAlkis id={props.name} projectId={props.project ? props.project.id : null}
                onSubmit={onSubmit}/>}
        {props.id>1&&<ImportDummy />}
    </div>
    );
};

export default ImportForm;
